// Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.

import { Link } from "react-router-dom";
import { CloudResource } from "~/generated/graphql";
import { DetailData } from "~/components/Details/Detail";
import { ROUTES } from "~/routing/routes";
import { capitalize } from "~/tools";

export function HeaderPresetResource(
  cloudResource?: CloudResource
): DetailData[] {
  return [
    {
      label: "Resource Name",
      value: cloudResource?.name,
    },
  ];
}

export function DetailsColumnFirst(
  cloudResource?: CloudResource
): DetailData[] {
  return [
    {
      label: "Fleet Control ID",
      value: cloudResource?.id,
      clipboard: true,
    },
    {
      label: "Resource ID",
      value: cloudResource?.fullCloudResourceId,
      clipboard: true,
    },
    {
      label: "Resource Type",
      value:
        cloudResource?.type +
        (cloudResource?.subtype ? "/" + cloudResource.subtype : ""),
      clipboard: true,
    },
    {
      label: "OS type",
      value: capitalize(findMetadataByPhrase("OSType", cloudResource) ?? "-"),
      clipboard: false,
    },
  ];
}

export function DetailsColumnSecond(
  cloudResource?: CloudResource
): DetailData[] {
  function DisplayAccountLink() {
    if (!cloudResource?.cloudAccount) {
      return undefined;
    }

    return (
      <Link to={ROUTES.accounts.generateDetails(cloudResource.cloudAccount.id)}>
        {cloudResource?.cloudAccount.name}
      </Link>
    );
  }

  return [
    {
      label: "Account",
      value: cloudResource?.cloudAccount
        ? cloudResource.cloudAccount.name
        : cloudResource?.providerId,
      clipboard: false,
      renderComponent: DisplayAccountLink,
    },
    {
      label: "Location",
      value: cloudResource?.region,
      clipboard: false,
    },
    {
      label: "IP Address",
      value:
        safeParse(findMetadataByPhrase("PublicIpAddress", cloudResource)) ??
        "-",
    },
    {
      label: "Description",
      value: null,
      clipboard: false,
    },
  ];
}

const findMetadataByPhrase = (
  phrase: string,
  cloudResource?: CloudResource
): string | undefined => {
  return cloudResource?.cloudMetadata?.find((res) => res.key === phrase)?.value;
};

const safeParse = (input?: string): string | undefined => {
  try {
    const parsed = JSON.parse(input ?? "");
    return typeof parsed === "string" ? parsed : undefined;
  } catch {
    return input;
  }
};
